jQuery(function () {

    var $ = jQuery;

    $(window).load(function () {
        var breakpoint = 768;
        var width = $(window).width();

        // we only append videos and allow them to be shown/hidden on Desktop
        // Tablet and mobile just get linked images.
        if (width > breakpoint) {

            // append the videos at start up.
            var images = $(".panel-images .panel-images-wrapper img").each(function (index) {

                // here is where all the videos are hosted
                var videopath = "/wp-content/themes/child-mcmaster/assets/videos/";

                var src = $(this).prop("src");
                if (!src && $(this).attr('lazy-src')) {
                    src = $(this).attr('lazy-src');
                }
                var file = src.substr(src.lastIndexOf("/") + 1);
                var name = file.substr(0, file.lastIndexOf("."));

                // replace with video with the same name;
                var videosrc = videopath + name + ".mp4";

                var video = $('<video />', {
                    src: videosrc,
                    type: 'video/mp4',
                    loop: "loop",
                    preload: "none",
                    muted: "muted"
                });
                $(video).append("Your browser does not support the video tag.");
                $(video).toggleClass("hide");

                //place it in the sibling video div container
                var videodiv = $(this).siblings(".panel-video");
                $(videodiv).append(video);
            });

            // events for videos
            $(".panel-images .panel-images-wrapper").on("mouseleave", function (e) {
                $(this).find("video").get(0).currentTime = 0;

                if ($(this).find("img.background").hasClass("hide")) {
                    $(this).find(".panel-video video").addClass("hide");
                    $(this).find("img.background").removeClass("hide");
                }
                $(window).trigger('video-box-end');

            });

            $(".panel-images .panel-images-wrapper").on("mouseenter", function (e) {

                if ($(this).find(".panel-video video").hasClass("hide")) {
                    $(this).find(".panel-video video").removeClass("hide");
                    $(this).find("img.background").addClass("hide");
                }

                var video = $(this).find("video").get(0);
                video.muted = true;
                var play = video.play();
                play.catch(function(e) {
                    window.e = e;
                });
                $(window).trigger('video-box-start');
            });

        }
    });




});
